import type { Platform } from './types';
import { webPlatform } from './platform_web';
import { capacitorPlatform } from './platform_capacitor';

export type {
  Platform,
  SharePayload,
  NotifyPayload,
  SaveToDownloadsResult,
  GeoPosition,
  PhotoCapture,
  NetworkStatus,
  RealtimeConnection,
  RealtimeHandlers,
} from './types';

declare global {
  interface Window {
    Capacitor?: { isNativePlatform: () => boolean };
  }
}

/** Resolved at first access. Re-evaluated never — Capacitor presence is fixed at load. */
export const platform: Platform =
  typeof window !== 'undefined' && window.Capacitor?.isNativePlatform()
    ? capacitorPlatform
    : webPlatform;
